<template>
  <v-snackbar
    v-model="visible"
    :color="color"
    :timeout="timeout"
    location="top right"
  >
    {{ message }}

    <template #actions>
      <v-btn
        icon
        variant="text"
        @click="visible = false"
        class="text-white"
      >
        <VIcon icon="tabler-x" class="text-white"/>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>

const visible = ref(false)
const message = ref('')
const color = ref('primary')
const timeout = ref(3000)

function show(msg, clr = 'primary', time = 4000) {
  message.value = msg
  color.value = clr
  timeout.value = time
  visible.value = true
}

defineExpose({ show })
</script>
